import React, { useEffect, useMemo } from "react";
import FullDataView from "./FullDataView.js";
import PaginationLoader from "./PaginationLoader.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import MobileGrid from "./Mobile/MobileGrid.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import logger from "../../../utils/logger.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useLocation } from "react-router-dom";
import findFolderIdByFileId from "./helpers/findFolderIdByFileId.ts";

// FUNC FETCHING FILE DATA IF ITS NOT WITHIN GLOBAL STATE
const fetchFile = async (mailId, fileId, callback, unsuccess) => {
  const response = await apiRequest(
    "Mails",
    "ReactGetMailFiles",
    {
      encryptedMailId: mailId,
      fileId: fileId,
    },
    "POST"
  );
  if (response.status === "success") {
    Object.keys(response.data?.files).length > 0
      ? callback(
          response.data.files[fileId].Type,
          fileId,
          response.data.files[fileId]
        )
      : unsuccess();
  } else {
    logger("lightboxContainer", "ReactGetMailFiles single file", response.data);
  }

  return response;
};

const DataSuccess = () => {
  const {
    getFilesData,
    getFileId,
    getMailId,
    setFileId,
    setCurrentFolder,
    getFoldersData,
  } = useMail();
  const { setLightBox } = useLightBox();
  const { mobileCondition } = useMediaQueries();

  const location = useLocation();

  const unsuccessFileCallback = () => {
    setFileId(null);
    const index = location.pathname.indexOf(getMailId()) + getMailId().length;
    const newUrl = location.pathname.slice(0, index);
    window.history.pushState({}, "", newUrl);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    //check if in url exist fileId and open lightbox with that file if true
    if (getFileId()) {
      const fileExistsInCurrentFolder = getFilesData()[getFileId()];
      if (fileExistsInCurrentFolder) {
        setLightBox(getFilesData()[getFileId()].Type, getFileId());
      } else {
        fetchFile(
          getMailId(),
          getFileId(),
          setLightBox,
          unsuccessFileCallback
        ).then((res) => {
          if (res.status !== "success") {
            const folderWithFile = findFolderIdByFileId(
              getFoldersData(),
              getFileId()
            );

            if (folderWithFile !== undefined) {
              setCurrentFolder(folderWithFile);
            }
          }
        });
      }
    }
  }, []);

  return useMemo(
    () => (
      <>
        {!mobileCondition ? <FullDataView /> : <MobileGrid />}
        <PaginationLoader />
      </>
    ),
    [mobileCondition]
  );
};

export default DataSuccess;
